"use client";

import NextError from "next/error";
import posthog from "posthog-js";
import { useEffect } from "react";

// `global-error.tsx` is Next.js's last-resort error boundary — it catches
// errors that escape every other React boundary (e.g. errors thrown inside
// the root layout). PostHog's `capture_exceptions: true` patches
// window.onerror + unhandledrejection but React render errors that get
// caught by error boundaries don't always reach those listeners. The
// explicit captureException here is the guarantee. PostHog dedupes by
// stack-trace hash so any overlap with auto-capture is harmless.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
